import { LuChartBar } from "react-icons/lu";
import Container from "../../../components/Container/Container";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import { createContext, useContext, useEffect, useState } from "react";
import { CardStat } from "../../../components/CardStat/CardStat";
import { LuCheck, LuClock, LuCpu, LuLock, LuTriangleAlert } from "react-icons/lu";
import { useTranslation } from "react-i18next";
import { UpcomingDueDates } from "../../../components/UpcomingDueDates/UpcomingDueDates";
import { LicensesByStatus } from "../../../components/LicensesByStatus/LicensesByStatus";
import { TopClientsByActiveLicenses } from "../../../components/TopClientsByActiveLicenses/TopClientsByActiveLicenses";
import { FinancialSummary } from "../../../components/FinancialSummary/FinancialSummary";
import { TopLocationByActiveLicenses } from "../../../components/TopLocationByActiveLicenses/TopLocationByActiveLicenses";
import { HeatMap } from "../../../components/HeatMap/HeatMap";
import { HidePrices } from "../../../components/HidePrices/HidePrices";
import LicenseService from "../../../services/LicensesService";
import { addTenDays, formatDateToYYYYMMDD } from "../../../utils/date";

const LicensesOverviewContext = createContext({
   hidePrices: true,
   updateHidePrices: () => { },
});

export function useLicensesOverview() {
   const context = useContext(LicensesOverviewContext);
   return context;
}

export function LicensesOverview({ ...props }) {
   const [dateFrom, setDateFrom] = useState(null);
   const [dateTo, setDateTo] = useState(null);
   const { t } = useTranslation();
   const [hidePrices, setHidePrices] = useState(true);
   const [analytics, setAnalytics] = useState();

   function downloadCsv() { }

   async function getAnalytics() {
      const response = await LicenseService.getAnalytics();
      const analytics = response.data;
      setAnalytics(analytics);
      console.log(analytics);
   }

   useEffect(() => {
      getAnalytics();
   }, []);

   return (
      <LicensesOverviewContext.Provider value={{ hidePrices, updateHidePrices: setHidePrices }}>
         <div className="consulta-container">
            <div className="search-list-wrapper">
               <SearchContainer
                  icon={<LuChartBar size={20} />}
                  title="Dashboard"
                  className="mb-0!"
                  containerClassName="pb-0!"
                  navigate={"../cadastro-licencas"}
                  hideAddButton={true}
               />
               <Container className="pt-0!">
                  <div className="flex flex-row items-center mb-3! px-0! mx-0! mt-0! justify-between!">
                     <div className="w-fit flex flex-row items-center gap-0">
                        {/* <div className="h-[14px] text-(--textColor) border! border-(--borderColor)! rounded-l-(--borderRadius) border-r-0! py-3! pr-3.5! pl-4! text-sm">
                           <span className="muted-sm p-0! mx-1!">Período</span>
                        </div>
                        <DateRangePicker
                           onUpdate={(values) => {
                              setDateFrom(new Date(values.range.from));
                              setDateTo(new Date(values.range.to));
                           }}
                           align="start"
                           triggerClassName="rounded-l-none!"
                           initialDateFrom={dateFrom ? new Date(dateFrom) : null}
                           initialDateTo={dateTo ? new Date(dateTo) : null}
                           locale={getUserLocale()}
                           showCompare={false}
                        /> */}
                        {/* <div className="ml-3!"> */}
                        {/* </div> */}
                     </div>
                     {/* <div className="w-fit flex flex-row-reverse items-center gap-2.5">
                        <Button
                           className="button-blue adicionar-button"
                           action="print"
                           icon={<MdOutlineLocalPrintshop size={18} />}
                           label={`Imprimir`}
                        />
                        <Button
                           className="button-white events-filters-button"
                           label={t("common.exportCSV")}
                           icon={<FiDownload size={17} />}
                           onClick={() => downloadCsv()}
                        />
                     </div> */}
                  </div>
               </Container>
               <Container>
                  <div className="w-full grid grid-cols-5 gap-3 -mt-2! mb-3!">
                     <CardStat
                        style={{ '--delay': 0 }}
                        title='Ativas'
                        icon={LuCheck}
                        className="fade-in"
                        value={`${analytics?.countByStates?.activeLicenses ?? 0}`}
                        color={`var(--activeLicensesColor)`}
                        url={`/licenses?technicalStatus=ACTIVE`}
                     />
                     <CardStat
                        style={{ '--delay': 1 }}
                        className="fade-in"
                        title='Vencem em 10 Dias'
                        icon={LuClock}
                        value={`${analytics?.countByStates?.upcomingDueLicenses ?? 0}`}
                        color={`var(--upcomingDueLicensesColor)`}
                        url={`/licenses?billingStatus=PENDING&dueDateFrom=${formatDateToYYYYMMDD(new Date())}&dueDateTo=${formatDateToYYYYMMDD(addTenDays())}`}
                     />
                     <CardStat
                        style={{ '--delay': 2 }}
                        className="fade-in"
                        title='Em atraso'
                        icon={LuTriangleAlert}
                        value={`${analytics?.countByStates?.overdueLicenses ?? 0}`}
                        color={`var(--expiredLicensesColor)`}
                        url={`/licenses?billingStatus=PENDING&dueDateTo=${formatDateToYYYYMMDD(new Date())}`}
                     />
                     <CardStat
                        style={{ '--delay': 3 }}
                        className="fade-in"
                        title='Bloqueadas'
                        icon={LuLock}
                        value={`${analytics?.countByStates?.blockedLicenses ?? 0}`}
                        color={`var(--blockedLicensesColor)`}
                        url={`/licenses?technicalStatus=BLOCKED`}
                     />
                     <CardStat
                        style={{ '--delay': 4 }}
                        className="fade-in"
                        title='Sem dispositivo'
                        icon={LuCpu}
                        value={`${analytics?.countByStates?.noAssociatedLicenses ?? 0}`}
                        color={`var(--noDeviceLicensesColor)`}
                        url={`/licenses?allocationStatus=FREE`}
                     />
                  </div>
                  <div className="grid w-full grid-cols-8 gap-3 mb-3!">
                     <div style={{ '--delay': 2 }} className="fade-in col-span-3">
                        <LicensesByStatus licensesStats={analytics?.countByStates} />
                     </div>
                     <div style={{ '--delay': 3 }} className="fade-in col-span-3">
                        <UpcomingDueDates overdues={analytics?.next10DaysUpcomingDues ?? []} />
                     </div>
                     <div style={{ '--delay': 4 }} className="fade-in col-span-2 h-full">
                        <FinancialSummary amounts={analytics?.calculateInvoicings?.[0]} />
                     </div>
                  </div>
                  <div className="grid w-full grid-cols-3 gap-3">
                     <TopClientsByActiveLicenses style={{ '--delay': 5 }} className="fade-in" topClients={analytics?.topUnitsByActiveLicenses ?? []} />
                     <TopLocationByActiveLicenses style={{ '--delay': 6 }} className="fade-in" topLocations={analytics?.topCitiesByActiveLicenses} />
                     <HeatMap style={{ '--delay': 7 }} className="fade-in" topLocations={analytics?.topStatesByActiveLicenses} />
                  </div>
               </Container>
            </div>
         </div>
      </LicensesOverviewContext.Provider>
   );
}